import { ol } from "../definitionsOl";

function calculateTransformation(fixedPoints, movingPoints) {
    const vector1 = {
        start: { x: fixedPoints[0][0], y: fixedPoints[0][1] },
        end: { x: fixedPoints[1][0], y: fixedPoints[1][1] },
    };

    const vector2 = {
        start: { x: movingPoints[0][0], y: movingPoints[0][1] },
        end: { x: movingPoints[1][0], y: movingPoints[1][1] },
    };

    const lengthFixed = Math.sqrt(
        Math.pow(vector1.end.x - vector1.start.x, 2) +
        Math.pow(vector1.end.y - vector1.start.y, 2)
    );

    const lengthMoving = Math.sqrt(
        Math.pow(vector2.end.x - vector2.start.x, 2) +
        Math.pow(vector2.end.y - vector2.start.y, 2)
    );

    const scale = lengthMoving / lengthFixed;

    const angle1 = Math.atan2(
        vector1.end.y - vector1.start.y,
        vector1.end.x - vector1.start.x
    );

    const angle2 = Math.atan2(
        vector2.end.y - vector2.start.y,
        vector2.end.x - vector2.start.x
    );

    const angle = angle2 - angle1;

    let tmpX = vector1.start.x * scale;
    let tmpY = vector1.start.y * scale;

    let rotX = Math.cos(angle) * tmpX - Math.sin(angle) * tmpY;
    let rotY = Math.sin(angle) * tmpX + Math.cos(angle) * tmpY;

    const translation = {
        x: vector2.start.x - rotX,
        y: vector2.start.y - rotY,
    };

    // const dotProduct =
    //     (vector1.end.x - vector1.start.x) * (vector2.end.x - vector2.start.x) +
    //     (vector1.end.y - vector1.start.y) * (vector2.end.y - vector2.start.y);

    let scaleX = (vector1.end.x - vector1.start.x) * (vector2.end.x - vector2.start.x);
    let flipX = scaleX < 0;

    let scaleY = (vector1.end.y - vector1.start.y) * (vector2.end.y - vector2.start.y);
    let flipY = scaleY < 0;

    return {
        translation: translation,
        rotation: angle,
        scale: scale,
        flip: [flipX, flipY],
    };
}

function changeOrigin(coordinates, origin, flip) {
    let x = flip.horizontally ? -1 : 1;
    let y = flip.vertically ? -1 : 1;
    for (let i = 0; i < coordinates.length; i++) {
        coordinates[i][0] = (origin.center[0] - coordinates[i][0]) * x;
        coordinates[i][1] = (origin.center[1] - coordinates[i][1]) * y;
    }
}

export function align(otherViewport, thisAlignmentPoints, otherAlignmentPoints) {
    changeOrigin(otherAlignmentPoints, otherViewport.getPosition(), otherViewport.getFlip());
    changeOrigin(thisAlignmentPoints, this.getPosition(), this.getFlip());

    const trans = calculateTransformation(otherAlignmentPoints, thisAlignmentPoints);

    const flip1 = otherViewport.getFlip();
    const flip2 = this.getFlip();

    let rotation = otherViewport.getPosition().rotation + trans.rotation;
    if (flip1.horizontally !== flip2.horizontally || flip1.vertically !== flip2.vertically) {
        rotation *= -1;
    }

    let currentPosition = this.getPosition();

    currentPosition.resolution = otherViewport.getPosition().resolution * trans.scale;
    delete currentPosition.zoom;


    // const annotationsSource = this.annotationsLayer.getSource();
    // annotationsSource.clear()
    // const format = new ol.format.WKT();
    // let features = [];
    // features.push(format.readFeature(`LINESTRING (${currentPosition.center[0]} ${currentPosition.center[1]}, ${currentPosition.center[0] - trans.translation.x} ${currentPosition.center[1] - trans.translation.y})`));
    // features.push(format.readFeature(`LINESTRING (${currentPosition.center[0] - 1000} ${currentPosition.center[1] - 1000}, ${currentPosition.center[0] - 1000} ${currentPosition.center[1] + 1000}, ${currentPosition.center[0] + 1000} ${currentPosition.center[1] + 1000}, ${currentPosition.center[0] + 1000} ${currentPosition.center[1] - 1000}, ${currentPosition.center[0] - 1000} ${currentPosition.center[1] - 1000})`));

    // annotationsSource.addFeatures(features);

    console.log(`rotation = ${rotation}, flip2.horizontally = ${flip2.horizontally}, flip2.vertically = ${flip2.vertically}`);

    currentPosition.center[0] -= trans.translation.x;
    currentPosition.center[1] -= trans.translation.y;
    currentPosition.rotation = rotation;
    this.setPosition(currentPosition);

    this.setFlip(flip1.horizontally, flip1.vertically);
}
